import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

interface SessionAssociationDialogProps {
  open: boolean;
  onAssociate: (dontAskAgain: boolean) => void;
  onDismiss: (dontAskAgain: boolean) => void;
}

export const SessionAssociationDialog = ({
  open,
  onAssociate,
  onDismiss,
}: SessionAssociationDialogProps) => {
  const [dontAskAgain, setDontAskAgain] = useState(false);

  const handleAssociate = () => {
    onAssociate(dontAskAgain);
  };

  const handleDismiss = () => {
    onDismiss(dontAskAgain);
  };

  return (
    <Dialog open={open} onOpenChange={handleDismiss}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Link Your Activity</DialogTitle>
          <DialogDescription>
            We noticed you've been active before signing in. Would you like to
            link your likes and views to your account?
          </DialogDescription>
        </DialogHeader>
        <div className="flex items-center space-x-2 py-4">
          <Checkbox
            id="dont-ask"
            checked={dontAskAgain}
            onCheckedChange={(checked) => setDontAskAgain(checked === true)}
          />
          <Label
            htmlFor="dont-ask"
            className="text-sm font-normal leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Don't ask me again
          </Label>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleDismiss}>
            Not Now
          </Button>
          <Button onClick={handleAssociate}>
            Yes, Link My Activity
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
